module.exports = __webpack_public_path__ + "img/horizontal_4_5_3016.c4dd124a.png";